import { Injectable, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
@Injectable({
  providedIn: 'root'
})
export class ModalService {
  public modalRef!: BsModalRef;
  config = {
    backdrop: false,
    ignoreBackdropClick: true,
    keyboard: false
  };
  constructor(private modalService: BsModalService) { }
  openModal(component: string | TemplateRef<any> | (new (...args: any[]) => any), options: any) {
    const config = { ...this.config, ...options };
    this.modalRef = this.modalService.show(component, config);
  }
  closeModal(modalID?: any) {
    this.modalRef.hide();
  }
}
